(function () {
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>';

  function init(root) {
    if (root.dataset.islReady === '1') return;
    root.dataset.islReady = '1';

    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var DATA = {};
    var dataEl = root.querySelector('[data-isl-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { DATA = {}; } }

    var modal = root.querySelector('[data-isl-modal]');
    var toast = root.querySelector('[data-isl-toast]');
    var qtyEl = root.querySelector('[data-isl-qty]');
    var qtyInput = root.querySelector('[data-isl-modal-qty]');
    var qty = 1;
    var toastTimer;

    function showToast(msg, withLink) {
      if (!toast) return;
      toast.textContent = msg;
      if (withLink) {
        var a = document.createElement('a');
        a.href = cartUrl;
        a.textContent = 'View cart';
        a.style.marginLeft = '8px';
        toast.appendChild(a);
      }
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.hidden = true; }, 4500);
    }

    function refreshCart() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    root.querySelectorAll('[data-isl-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        var btn = form.querySelector('button[type=submit]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'ADDING...'; }
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            if (res && res.status) {
              showToast(res.description || 'Could not add to cart.', false);
              return;
            }
            showToast('Added to cart.', true);
            refreshCart();
            if (modal) modal.hidden = true;
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            form.submit();
          });
      });
    });

    function setQty(n) {
      qty = Math.min(9, Math.max(1, n));
      if (qtyEl) qtyEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    }

    root.querySelectorAll('[data-isl-quickview]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = DATA[btn.getAttribute('data-isl-quickview')];
        if (!d || !modal) return;
        setQty(1);
        var img = root.querySelector('[data-isl-modal-img]');
        if (img) { img.src = d.image || ''; img.alt = d.title || ''; }
        var set = function (sel, val) {
          var el = root.querySelector(sel);
          if (el) el.textContent = val || '';
        };
        set('[data-isl-modal-title]', d.title);
        set('[data-isl-modal-price]', d.price);
        set('[data-isl-modal-blurb]', d.blurb);
        var idEl = root.querySelector('[data-isl-modal-id]');
        if (idEl) idEl.value = d.id;
        var linkEl = root.querySelector('[data-isl-modal-link]');
        if (linkEl) linkEl.href = d.url || '#';
        var feats = root.querySelector('[data-isl-modal-feats]');
        if (feats) {
          feats.innerHTML = '';
          (d.features || []).forEach(function (f) {
            if (!f) return;
            var row = document.createElement('div');
            row.className = 'isl-feat';
            row.innerHTML = CHECK + '<span></span>';
            row.querySelector('span').textContent = f;
            feats.appendChild(row);
          });
        }
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    if (modal) {
      var inc = root.querySelector('[data-isl-inc]');
      var dec = root.querySelector('[data-isl-dec]');
      var close = root.querySelector('[data-isl-modal-close]');
      if (inc) inc.addEventListener('click', function () { setQty(qty + 1); });
      if (dec) dec.addEventListener('click', function () { setQty(qty - 1); });
      if (close) close.addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-isl-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
